import { render, staticRenderFns } from "./RadioButtonLink.vue?vue&type=template&id=56ed9163"
import script from "./RadioButtonLink.vue?vue&type=script&lang=ts"
export * from "./RadioButtonLink.vue?vue&type=script&lang=ts"
import style0 from "./RadioButtonLink.vue?vue&type=style&index=0&id=56ed9163&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports